export default "__VITE_ASSET__qxRlM3RT__"